document.addEventListener('click', function (event) {
  const link = event.target.closest('.card__color-swatch-link');
  if (!link) return;

  if (link.classList.contains('is-active')) {
    // Second click on the already-previewed color: let it navigate to the product page.
    return;
  }

  const image = link.dataset.image;
  if (!image) return;

  event.preventDefault();

  const cardWrapper = link.closest('.card-wrapper');
  const img = cardWrapper && cardWrapper.querySelector('.card__media-image');
  if (img) {
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = image;
  }

  // This theme's cards fade in a second "hover" image over the whole card while
  // the mouse is over it (component-card.css .media--hover-effect). Without this,
  // the color swap above is masked by that crossfade until the mouse leaves.
  if (cardWrapper) {
    cardWrapper.classList.add('has-color-preview');
  }

  const swatchList = link.closest('.card__color-swatches');
  if (swatchList) {
    swatchList.querySelectorAll('.card__color-swatch-link.is-active').forEach(function (activeLink) {
      activeLink.classList.remove('is-active');
    });
  }
  link.classList.add('is-active');
});
